import {FooterCopyright, FooterMenu} from '@components/export';

export const Footer = () => {
    return <div className="footer-wrapper">
        <FooterMenu />
        <FooterCopyright />
    </div>;
};
